export class ResultStatusDto {
    isSuccess: boolean; // revert it to isSuccess
    errorMessage: string;
}
